<template src="./template.html"></template>


<script>
export default {
  name: "NewsList",
  props: {
    news_data: {
      type: Array,
      require: true
    }
  },
  data() {
    return {
      next: false,
      prev: false
    }
  },
  methods: {
    PrevPage() {
      if (this.prev) {
        this.$router.push(`/news/list/${this.$route.params.page - 1}`)
      }
    },
    NextPage() {
      if (this.next) {
        this.$router.push(`/news/list/${this.$route.params.page + 1}`)
      }
    }
  },
  computed: {
    page_news() {
      if (this.news_data.length <= 0) {
        return []
      }
      else {
        let page_amount = 10
        let page = this.$route.params.page
        return this.news_data.slice(page * page_amount - page_amount, page * page_amount)
      }
    }
  },
  watch: {
    news_data() {
      let page_amount = 10
      let page = this.$route.params.page
      let count = page * page_amount
      this.news_data.length > count ? this.next = true : this.next = false
      page == 1 ? this.prev = false : this.prev = true
    },
    "$route"() {
      let page_amount = 10
      let page = this.$route.params.page
      let count = page * page_amount
      this.news_data.length > count ? this.next = true : this.next = false
      page == 1 ? this.prev = false : this.prev = true
    }
  }
}
</script>